module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay-selector"
  }, [_c('c-action-sheet', {
    attrs: {
      "visible": _vm.inlineVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.inlineVisible = $event
      }
    }
  }, [_c('div', {
    slot: "title"
  }, [_vm._v("选择支付方式")]), _vm._v(" "), _c('div', {
    slot: "menu"
  }, _vm._l((_vm.baseEpayment), function(configItem, key) {
    return _c('c-cell-container', {
      key: key,
      staticClass: "item-cell-container mt-0"
    }, [_c('c-cell-item', {
      attrs: {
        "icon": configItem.icon,
        "title": configItem.name,
        "point": false
      },
      nativeOn: {
        "click": function($event) {
          _vm.selectPayType(configItem.type)
        }
      }
    }, [_c('i', {
      staticClass: "s-icon-arrow-right",
      slot: "foot"
    })])], 1)
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91ebbc88","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/logic-components/pay-selector/index.vue
// module id = 1067
// module chunks = 2